parasails.registerPage('giftexchange', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    receivedGiftsToShow: 10,
    showLoadMoreButton: false,
    giftsTotal: 0
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    this.checkButtonEnablers();
    this.giftsTotal = this.totalGiftsReserved;
    io.socket.on(this.eventData.id, (params) => {
      switch(params.eventType) {
        case 'giftCodeGranted': this.updateSurveyData(); break;
        case 'giftreceived': this.updateSurveyData(); break;
        default:
          console.log('Received Socket Event with params: ' + JSON.stringify(params));
      }
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    //giftCodeGranted
    //giftreceived
    giftGiven: function(deviceidentifier, giftCode) {
      io.socket.post('/giftreceived', { eventid: this.eventData.id, deviceID: deviceidentifier, giftCode: giftCode});
    },
    checkButtonEnablers: function() {
      console.log("Hello");
      console.log("this.giftsGivenData.length = " + this.giftsGivenData.length);

      if(this.giftsGivenData.length < this.receivedGiftsToShow) {
        this.showLoadMoreButton = false;
      } else {
        this.showLoadMoreButton = true;
      }
    },
    updateSurveyData: async function() {
      var newResults = await Cloud.getSurveyResults.with({eventID: this.eventData.id, partindex: this.partindex});
      this.surveyResultsData = newResults.SurveyResultsData;
      this.giftsPendingData = newResults.giftsPendingData;
      this.giftsGivenData = newResults.giftsGivenData;
      this.giftsTotal = this.totalGiftsReserved;

      this.checkButtonEnablers();
    },
    loadMoreGiftsReceived: function() {
      this.receivedGiftsToShow += 10;
      if(this.receivedGiftsToShow > this.giftsGivenData.length) {
        this.receivedGiftsToShow = this.giftsGivenData.length;
        this.showLoadMoreButton = false;
      } else {
        this.showLoadMoreButton = true;
      }
    }
  }
});
